<app-auth-layout>
  @if (!sent) {
  <mat-card-title>
    <div class="flex items-center gap-3">
      <span class="h-11 w-11 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center flex-shrink-0"><mat-icon>lock_reset</mat-icon></span>
      <div>
        <h1 class="text-2xl font-bold text-neutral-800">Reset your password</h1>
        <p class="text-sm text-neutral-500 font-normal mt-0.5">We'll email you a new one</p>
      </div>
    </div>
  </mat-card-title>
  <mat-card-content>
    <p class="text-sm text-neutral-500 mt-4">Enter the username or email you sign in with, and we'll email you a link to choose a new password.</p>

    <form #resetForm="ngForm" (ngSubmit)="onSubmit(resetForm)">
      <div class="mt-5">
        <label class="text-sm font-medium text-neutral-700" for="forgot-email">Username or email</label>
        <div class="mt-1">
          <input
            id="forgot-email"
            class="p-2.5 rounded-lg border border-neutral-300 bg-neutral-50 w-full transition-colors focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400"
            name="forgotPassEmail"
            type="text"
            autocomplete="username"
            placeholder="you@nustone.co.uk"
            [(ngModel)]="forgotPassEmail"
            required
            #emailInput="ngModel"
          />
        </div>
        @if (emailInput.invalid && (emailInput.dirty || emailInput.touched)) {
        <div class="mt-1 text-xs text-red-500">
          @if (emailInput.errors?.['required']) { <span>Enter your username or email</span> }
        </div>
        }
      </div>

      <div class="mt-6">
        <button type="submit" [disabled]="submitting"
          class="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:shadow-lg hover:shadow-amber-300 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-60 disabled:cursor-not-allowed disabled:shadow-none">
          @if (submitting) {
            <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span>
            Sending&hellip;
          } @else {
            Reset password
          }
        </button>
      </div>

      <div class="mt-4 text-center">
        <a class="text-amber-600 hover:text-amber-700 text-xs font-medium underline" routerLink="/login">Back to login</a>
      </div>
    </form>
  </mat-card-content>
  } @else {
  <mat-card-title>
    <div class="flex items-center gap-3">
      <span class="h-11 w-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0"><mat-icon>mark_email_read</mat-icon></span>
      <div>
        <h1 class="text-2xl font-bold text-neutral-800">Check your inbox</h1>
        <p class="text-sm text-neutral-500 font-normal mt-0.5">A reset link is on its way</p>
      </div>
    </div>
  </mat-card-title>
  <mat-card-content>
    <p class="text-sm text-neutral-500 mt-4">If an account exists for <span class="font-semibold text-neutral-700">{{ forgotPassEmail }}</span>, we've emailed it a link to choose a new password. The link works once, for 1 hour.</p>
    <div class="mt-6">
      <a routerLink="/login"
        class="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:shadow-lg hover:shadow-amber-300 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all">
        Back to login
      </a>
    </div>
  </mat-card-content>
  }
</app-auth-layout>
